import 'jquery';
import 'jquery-ujs';
import 'angular';
import 'angular-ui-router';
import 'restangular';
import 'ng-infinite-scroll';
import 'vendor/angular-ui/bootstrap';
import 'vendor/text-angular.js';
import 'vendor/text-angular-sanitize.min.js';
import 'ng-rollbar';
import 'vendor/ezidebit_2_0_0.min.js';
import 'vendor/angular-flash';
import 'ngreact';

import 'modules/components/_components.js';
import 'modules/shared/_shared.js.coffee';
import 'react/entry_points/shared/recaptcha.tsx';

const requireAll = (requireContext) => {
  requireContext.keys().map((item) => requireContext(item));
};
requireAll(require.context('modules/book_and_pay', true));
requireAll(require.context('modules/shared', true));
requireAll(require.context('modules/filters', true));
requireAll(require.context('modules/components/contacts/forms', true));

$.ajaxSetup({ cache: true });
